export default __webpack_public_path__ + "static/Pay-bills-instantly-3eef485e553e5c07b2020cbbb34918cd.png";